import * as BIEUI from "react-bootstrap";
import { useEffect, useState } from "react";
import { FiPower } from "react-icons/fi";
import { BiLock } from "react-icons/bi";
import '../pri.css';
import jwt_decode from "jwt-decode";
import CountdownTimer from '../Authentication/CountdownTimer';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { config } from '../CommonUtils/CommonURLS';
import { useDispatch, useSelector } from "react-redux";
import EmblemAndhraPradesh from "../EmblemAndhraPradesh.png";
import { AiOutlineUser } from "react-icons/ai";
import ImageComponent from "../CommonUtils/ImageViewCommonCode";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import axios from "axios";
import qs from "qs";

const Header = () => {



    const role_code_gen = useSelector((state) => state.reducers?.commonmastersreducer?.role_code);
    const roledesc_gen = useSelector((state) => state.reducers?.commonmastersreducer?.roledesc);

    // console.log('ddddd',roledesc_gen);


    function dateToISOLikeButLocal(date) {
        const offsetMs = date.getTimezoneOffset() * 60 * 1000;
        const msLocal = date.getTime() - offsetMs;
        const dateLocal = new Date(msLocal);
        const iso = dateLocal.toISOString();
        const isoLocal = iso.slice(0, 19);
        return isoLocal;
    }
    var token = localStorage.getItem("token");
    var decoded = jwt_decode(token);
    var date = new Date(decoded.exp * 1000);
    const dispatch = useDispatch();
    const logindetails = useSelector((state) => state.reducers?.loginreducer.userLoginDetials);
    dispatch({ type: "LOGINUSERNAME", payload: logindetails[0]?.dy_tahsildar });
    const navigate = useNavigate();


    const logout = () => {
        saveLoginTracker();
    };


    React.useEffect(() => {
        const timer = setInterval(() => { // Creates an interval which will update the current data every minute
        }, 60);
        return () => {
            clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
        }
    }, []);
    function ChangePassword() {
        navigate("/changePassword")
    }


    // const KillToken = () => {

    //     let refreshToken = JSON.parse(localStorage.getItem("refresh_token"));


    //     const payload = {
    //         refresh_token: refreshToken
    //     };

    //     CommonAxiosPost("killtoken", payload).then((response) => {

    //     });


    // };

    const saveLoginTracker = async () => {
        const token = localStorage.getItem("token");
        const refreshToken = JSON.parse(localStorage.getItem("refresh_token"));

        try {
            if (token) {
                await CommonAxiosGet("v1/logout");
            }

            if (refreshToken) {
                await CommonAxiosPost("killtoken", { refresh_token: refreshToken });
            }

        } catch (err) {
            console.warn("Idle logout API failed:", err?.response?.status);
        } finally {
            localStorage.clear();
            window.location.href = config.url.UI_URL;
        }
    };

    useEffect(() => {
            const handleScroll = () => {
                const navbar = document.querySelector(".panchayat-dashboard-navbar");
                if (window.scrollY > 10) {
                    navbar.classList.add("scrolled");
                } else {
                    navbar.classList.remove("scrolled");
                }
            };
    
            window.addEventListener("scroll", handleScroll);
    
            return () => window.removeEventListener("scroll", handleScroll);
        }, []);
    // const dispatch =useDispatch()
    return (
        <BIEUI.Navbar collapseOnSelect expand="lg" fixed="top" className="panchayat-dashboard-navbar bg-white">
            <BIEUI.Navbar.Brand>
                <ImageComponent imagepath={"Assets/1733296766878_logo.png"} typePhoto={"logo"} />
                <ImageComponent imagepath={"Assets/1733296751655_logo-text.png"} typePhoto={"logotext"} />
            </BIEUI.Navbar.Brand>
            <BIEUI.Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <BIEUI.Navbar.Collapse id="responsive-navbar-nav">
                <BIEUI.Nav className="me-auto"></BIEUI.Nav>
                <BIEUI.Nav>
                    <BIEUI.NavDropdown className="header-dropdown-setting" id="basic-nav-dropdown" title={<div className="login-role"><span><AiOutlineUser className="user-icon-header" /></span>{roledesc_gen !== "" && <><p>{`Role: ${roledesc_gen} (${role_code_gen})`}</p>
                    </>}<span>{logindetails[0]?.dy_tahsildar}</span></div>}>
                        <BIEUI.NavDropdown.Item onClick={logout}><FiPower size={18} onClick={logout} /> Sign Out</BIEUI.NavDropdown.Item>
                    </BIEUI.NavDropdown>
                </BIEUI.Nav>
            </BIEUI.Navbar.Collapse>
        </BIEUI.Navbar>
    );
}
export default Header;